import PropTypes from 'prop-types';

export default PropTypes.shape({
  from: PropTypes.isRequired,
  to: PropTypes.isRequired,
});
